import HttpRequest from'../../../http/index.js';import {MARS_CORE_SERVER_PATH,PRODUCT_STOCK_PATH}from'@monorepo/shared';/*
 * @Author: 刘欢
 * @LastEditors: 毛和水
 * @Date: 2024-03-12 20:11:57
 * @LastEditTime: 2024-07-31 17:05:54
 * @Description: 新增或编辑物品档案
 */
/** 保存物品信息 */
const saveProducts = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials.json`,
        data,
        method: 'POST',
    });
};
/** 根据id查询物品集合 */
const getProducts = (id, location_id) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials/${id}.json?location_id=${encodeURIComponent(location_id)}`,
        method: 'POST',
    });
};
/** 获取物品列表 */
const getProductList = (data, isReturnAxiosError) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials.json`,
        data,
        options: {
            isReturnAxiosError,
        },
    });
};
/** 更新物品信息 */
const updateProduct = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials.json`,
        data,
        method: 'PUT',
    });
};
/** 根据id删除物品 */
const deleteProductById = (id, location_id, type) => {
    // Construct URL with conditional parameter
    const baseUrl = `${MARS_CORE_SERVER_PATH}/product_variant_materials/${id}.json`;
    const locationParam = `location_id=${location_id}`;
    const deleteSourceParam = type ? `delete_source=${type}` : '';
    // Combine parameters with proper formatting
    const url = `${baseUrl}?${deleteSourceParam}${deleteSourceParam ? '&' : ''}${locationParam}`;
    return HttpRequest({
        url,
        method: 'DELETE',
    });
};
/** 自动生成代码、条码优化 */
const getCode = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_resources/archives_setting/apply.json`,
        data,
        method: 'GET',
    });
};
/** 批量更新物品信息 */
const batchUpdateProduct = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials/batch_edit_async.json`,
        data,
        method: 'PUT',
    });
};
/** 导入物品 */
const importProducts = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials/async_import.json`,
        data,
        method: 'POST',
    });
};
/** 导出物品 */
const exportProducts = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials/async_export.json`,
        data,
        method: 'POST',
    });
};
/** 导出成套件 */
const exportKitItems = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_material_kit/async_export.json`,
        data,
        method: 'POST',
    });
};
/** 自动生成代码、条码优化 */
const getItemCode = () => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_resources/archives_setting/apply_item_code.json`,
        method: 'GET',
    });
};
const getAliCode = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_file_libraries/get_tencent_temp_credential_v2.json`,
        data,
        method: 'GET',
    });
};
const getTcTempCredential = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_file_libraries/tencent/get_temp_credential.json`,
        data,
        method: 'GET',
    });
};
const getTcConfiguration = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_file_libraries/tencent/get_bucket_config.json`,
        data,
        method: 'GET',
    });
};
/** 开启销售管理 */
const updateSaleActiveIs = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/products/update_sale_active_is.json`,
        data,
        method: 'PUT',
    });
};
/**
 * 物品下发
 */
const productIssuance = (data) => {
    const { location_id_list, variant_id_list } = data;
    // Helper function to encode array parameters
    const encodeArrayParams = (key, values) => {
        return values
            .map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');
    };
    // Construct query parameters
    const queryParams = [
        encodeArrayParams('location_id_list', location_id_list),
        encodeArrayParams('variant_id_list', variant_id_list),
    ].join('&');
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_materials/header_down.json?${queryParams}`,
        method: 'POST',
    });
};
// 物品查询模板列表
const getQueryTemplateList = (data) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template.json`,
        data,
        method: 'GET',
    });
};
// 创建物品查询模板
const createQueryTemplate = (data) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template.json`,
        data,
        method: 'POST',
    });
};
// 更新物品查询模板
const editQueryTemplate = (id, data) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template/${id}.json`,
        data,
        method: 'PUT',
    });
};
// 获取物品查询模板详情
const getQueryTemplateDetail = (id) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template/${id}.json`,
        method: 'GET',
    });
};
// 删除物品查询模板
const delQueryTemplate = (id) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template/${id}.json`,
        method: 'DELETE',
    });
};
// 批量删除物品查询模板
const batchDelQueryTemplate = (id_list) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template/batch_delete.json?id_list=${id_list}`,
        method: 'DELETE',
    });
};
// 导入商品excel
const importItemExcel = (data) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template/import_item.json`,
        data,
        method: 'POST',
    });
};
// 导出商品excel
const exportItemExcel = (data) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/item_search_template/export_item.json`,
        data,
        method: 'POST',
    });
};
// 根据虚拟物品id读取真实物品列表
const getProductByVirtualId = (id) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_material_virtual/${id}.json`,
        method: 'GET',
    });
};
// 根据虚拟物品id读取成套件配件列表
const getProductByKitsId = (kit_item_id_list) => {
    // 将 kit_item_id_list 转换为查询字符串
    const queryString = new URLSearchParams({
        kit_item_id_list: kit_item_id_list.join(','),
    }).toString();
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_material_kit.json?${queryString}`,
        method: 'GET',
    });
};
// 根据虚拟物品id及门店id读取真实物品列表
const getProductByVirtualIdAndLocation = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_material_virtual/list_relation_by_virtual_id_and_location.json`,
        data,
        method: 'GET',
    });
};
/** 保存虚拟物品/真实物品关系 */
const saveVirtualProducts = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_material_virtual.json`,
        data,
        method: 'POST',
    });
};export{batchDelQueryTemplate,batchUpdateProduct,createQueryTemplate,delQueryTemplate,deleteProductById,editQueryTemplate,exportItemExcel,exportKitItems,exportProducts,getAliCode,getCode,getItemCode,getProductByKitsId,getProductByVirtualId,getProductByVirtualIdAndLocation,getProductList,getProducts,getQueryTemplateDetail,getQueryTemplateList,getTcConfiguration,getTcTempCredential,importItemExcel,importProducts,productIssuance,saveProducts,saveVirtualProducts,updateProduct,updateSaleActiveIs};//# sourceMappingURL=virtualItem.service.js.map
